import confetti from "canvas-confetti";

/**
 * Triggers a confetti animation with specified properties.
 *
 * This function invokes a confetti animation at the center of the screen
 * with predefined parameters such as particle count, velocity, and spread angle.
 *
 * Key properties:
 * - Particle count: 200
 * - Start velocity: 30
 * - Spread angle: 360 degrees
 * - Origin: Center of the screen (x: 0.5, y: 0.5)
 *
 * The animation creates a celebratory visual effect suitable for events such as
 * user achievements, celebrations, or special announcements.
 */
export const triggerConfetti = () => {
  confetti({
    particleCount: 200, // Anzahl an Partikeln
    startVelocity: 30, // Geschwindigkeit
    spread: 360, // Streuwinkel
    origin: {
      x: 0.5, // Zentrum horizontal
      y: 0.5, // Zentrum vertikal
    },
  });
};
